import React, { useState, useEffect, useRef } from "react";
import CarouselCard from "../../../Components/CarouselCard/CarouselCard";
import logo1 from "../../../Assets/carousel/img1.png";
import logo2 from "../../../Assets/carousel/img2.png";
import logo3 from "../../../Assets/carousel/img3.png";
import logo5 from "../../../Assets/carousel/img5.png";
import "./Carousel.css";

import leftbtn from "../../../Assets/left.png";
import rightbtn from "../../../Assets/right.png";

const Carousel = () => {
  const elements = [
    {
      logo: logo1,
      heading: "Free Chat",
      cardno: "1",
      content:
        "Choose us for genuine matches, free chats, and a seamless, trustworthy experience designed to help you find true love.",
    },
    {
      logo: logo2,
      heading: "Read Biodata",
      cardno: "2",
      content:
        "Experience unmatched connections with our unique voice feature, making your biodata come alive and enhancing every match effortlessly.",
    },
    {
      logo: logo3,
      heading: "Person Verification",
      cardno: "3",
      content:
        "Reliable, thorough, meticulous screening ensuring perfect matches for a lifetime of happiness. Trust us for authentic connections",
    },
    {
      logo: logo5,
      heading: "Community wise match",
      cardno: "4",
      content:
        "Exclusive community-centric matchmaking, fostering cultural connection. Discover your perfect match within our vibrant community network.",
    },
  ];

  const [active, setActive] = useState(1);
  const carouselRef = useRef(null);

  const btnpressprev = () => {
    if (active > 1) {
      const scrollWidth = carouselRef.current.clientWidth > 430 ? 430 : carouselRef.current.clientWidth - 80;
      carouselRef.current.scrollLeft -= scrollWidth;
      setActive((prevActive) => prevActive - 1);
    }
  };

  const btnpressnext = () => {
    if (active < elements.length) {
      const scrollWidth = carouselRef.current.clientWidth > 430 ? 430 : carouselRef.current.clientWidth - 80;
      carouselRef.current.scrollLeft += scrollWidth;
      setActive((prevActive) => prevActive + 1);
    }
  };


  const [activeIndex, setActiveIndex] = useState(0);

  const btnPressPrev = () => {
    setActiveIndex((prevIndex) => (prevIndex - 1 + slides.length) % slides.length);
  };

  const btnPressNext = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  const slides = [
    {
      logo: logo1,
      title: "Free Chat",
      description: "Choose us for genuine matches, free chats, and a seamless, trustworthy experience designed to help you find true love.",
    },
    {
      logo: logo2,
      title: "Read Biodata",
      description: "Experience unmatched connections with our unique voice feature, making your biodata come alive and enhancing every match effortlessly.",
    },
    {
      logo: logo3,
      title: "Person Verification",
      description: "Reliable, thorough, meticulous screening ensuring perfect matches for a lifetime of happiness. Trust us for authentic connections.",
    },
    {
      logo: logo5,
      title: "Community wise match",
      description: "Exclusive community-centric matchmaking, fostering cultural connection. Discover your perfect match within our vibrant community network.",
    },
  ];

  return (
    <div className="container">
      <div className="homepage-carousel">
        <div className="carousel_container" ref={carouselRef}>
          {elements.map((element) => (
            <CarouselCard
              key={element.cardno}
              active={active}
              btnpressnext={btnpressnext}
              btnpressprev={btnpressprev}
              cardno={element.cardno}
              logo={element.logo}
              heading={element.heading}
              content={element.content}
            />
          ))}
        </div>
      </div>
      {/* <>
            <img
              className="btn-for-homepage-carousel btn_left"
              src={leftbtn}
              onClick={btnpressprev}
              alt=""
            />
            <img
              className="btn-for-homepage-carousel btn_right"
              src={rightbtn}
              onClick={btnpressnext}
              alt=""
            />
          </> */}
      <div className="responsive-carousel mb-5 mt-3">
        <div className="carousel-container">
          {slides.map((slide, index) => (
            <div
              key={index}
              className="carousel-card"
              style={{
                display: index === activeIndex ? 'block' : 'none', // Display only the active slide
                background: index === activeIndex
                  ? "linear-gradient(180deg, #f97096 11.11%, rgba(207, 22, 111, 0.5) 100%)"
                  : 'transparent',
                color: index === activeIndex ? 'white' : 'inherit',
              }}
            >
              <img className="card-logo" src={slide.logo} alt={`${slide.title} logo`} />
              <h4>{slide.title}</h4>
              <p>{slide.description}</p>
            </div>
          ))}
        </div>

        {/* Navigation Buttons */}
        <img
          className="new-slider-cmn-btn new-slider-left-btn"
          src={leftbtn}
          onClick={btnPressPrev}
          alt="Previous"
        />
        <img
          className="new-slider-cmn-btn new-slider-right-btn"
          src={rightbtn}
          onClick={btnPressNext}
          alt="Next"
        />
      </div>
    </div>
  );
};

export default Carousel;
